<script setup>
const props = defineProps({
  placeholder: {
    type: String,
    required: false,
  },
  isAdminSignup: {
    type: Boolean,
    required: false,
  }
})
const { transitionColour } = useTailwindConfig();

// defineModel() is used to translate A v-model relationship from parent to child through components
const password = defineModel()

const showPassword = ref(false);
</script>

<template>
  <div class="relative">
    <UInput v-model="password" :type="showPassword ? 'text' : 'password'" :placeholder="placeholder" class="w-full"
      icon="heroicons:lock-closed" :autocomplete="isAdminSignup ? 'new-password' : 'current-password'"
      :data-form-type="isAdminSignup ? 'other' : 'password'" :name="isAdminSignup ? 'admin-password' : 'password'"
      size="xl">
      <template #trailing>
        <UButton color="neutral" variant="link" size="sm" :icon="showPassword ? 'i-lucide-eye-off' : 'i-lucide-eye'"
          :aria-label="showPassword ? 'Hide password' : 'Show password'" :aria-pressed="showPassword"
          aria-controls="password" @click="showPassword = !showPassword" />
      </template>
    </UInput>
  </div>
</template>